import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=1a6dd9ce&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
import style0 from "./Rules.vue?vue&type=style&index=0&id=1a6dd9ce&prod&lang=scss&scoped=true"
import style1 from "./Rules.vue?vue&type=style&index=1&id=1a6dd9ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6dd9ce",
  null
  
)

export default component.exports